// make a function that toggles the dropdown menu on click on mobile
import useBreakpoints from '../functions/useBreakpoints';

$(document).ready(function () {
    const {isBreakpoint} = useBreakpoints();

    const DROPDOWN_BUTTONS_SELECTOR = '[data-toggle="dropdown"]';
    const DROPDOWN_MENU_SELECTOR = '.dropdown-menu';

    // Using event delegation for dropdown buttons
    $(document).on('click', DROPDOWN_BUTTONS_SELECTOR, function() {
        if (isBreakpoint('lg')) {
            return false;
        }
        let menu = $(this).next();

        const toggle = menu.attr('aria-expanded') === 'false';

        clickBesidesMenu(menu);
        toggleDropdown(menu, toggle);
    });

    // Using event delegation for dropdown hover
    $(document).on('mouseenter', '.dropdown', function() {
        if (!isBreakpoint('lg')) {
            return false;
        }

        let menu = $(this).find(`> ${DROPDOWN_MENU_SELECTOR}`);
        toggleDropdown(menu, true);
    });

    $(document).on('mouseleave', '.dropdown', function() {
        if (!isBreakpoint('lg')) {
            return false;
        }

        let menu = $(this).find(`> ${DROPDOWN_MENU_SELECTOR}`);
        toggleDropdown(menu, false);
    });

    function toggleDropdown(menu, toggle = true) {
        menu.attr('aria-expanded', toggle);
    }

    // Improved click outside handler
    function clickBesidesMenu(menu) {
        // Remove any existing handlers first to prevent duplicates
        $(window).off('click.dropdown');

        // Namespace the event to make it easier to remove
        $(window).on('click.dropdown', (event) => {
            if (!$(event.target).closest(menu.parent()).length) {
                toggleDropdown(menu, false);
                return false;
            }
        });
    }
});